import { IApplicationState } from 'shared/types/redux';

export const selectIsCianAuthorizedModalOpen = (state: IApplicationState): boolean =>
  state.landing.isCianAuthorizedModalOpen;
